import { render, staticRenderFns } from "./EUDRDeforestationAssessment.vue?vue&type=template&id=8cbae2e6&scoped=true"
import script from "./EUDRDeforestationAssessment.vue?vue&type=script&lang=js"
export * from "./EUDRDeforestationAssessment.vue?vue&type=script&lang=js"
import style0 from "./EUDRDeforestationAssessment.vue?vue&type=style&index=0&id=8cbae2e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbae2e6",
  null
  
)

export default component.exports